module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/result01-a462a6ea63a11a5657aeee8803bfcd8b.png";